/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pdfs_Not_SupportedInputs */

const en_common_pdfs_not_supported = /** @type {(inputs: Common_Pdfs_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDFs Aren't Supported`)
};

const es_common_pdfs_not_supported = /** @type {(inputs: Common_Pdfs_Not_SupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los PDF no son compatibles aquí`)
};

/**
* | output |
* | --- |
* | "PDFs Aren't Supported" |
*
* @param {Common_Pdfs_Not_SupportedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_pdfs_not_supported = /** @type {((inputs?: Common_Pdfs_Not_SupportedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pdfs_Not_SupportedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_pdfs_not_supported(inputs)
	return en_common_pdfs_not_supported(inputs)
});